import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "message-text",
  "use": "message-text-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"message-text\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 1a1 1 0 011-1h14a1 1 0 011 1v11a1 1 0 01-1 1H5.5l-4 2.5S0 16.5 0 15V1zm2 10V2h12v9H2z\" /><path d=\"M3 5a1 1 0 011-1h8a1 1 0 110 2H4a1 1 0 01-1-1zm0 3a1 1 0 011-1h4a1 1 0 010 2H4a1 1 0 01-1-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol